import { TaskDataString } from './task.model';

/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export interface WorkflowNotificationTrigger {
  object_reference: string;
  trigger_options: TriggerOptions;
  recipient_options: RecipientOptions;
  _id: string;
}

export interface UpdateWorkflowNotificationTrigger {
  object_reference: string;
  trigger_options: TriggerOptions;
  recipient_options: RecipientOptions;
}

export interface TriggerOptions {
  trigger_groups?: string[];
  trigger_types?: TriggerOptionsTypes;
}

export interface TriggerOptionsTypes {
  task_closed?: boolean;
  incident_trigger_all?: boolean;
  incidents?: TriggerTypeIncident[];
}
export interface TriggerTypeIncident {
  state_id?: number;
  data?: TaskDataString;
}

export enum TriggerTypeEnum {
  TASK_CLOSED = 'TASK_CLOSED',
  INCIDENT_TRIGGER = 'INCIDENT_TRIGGER'
}

export interface RecipientOptions {
  // emails?: string[]; // Not yet implemented, requires some sort of "unsubscribe" feature
  employees?: string[];
  employeegroups?: string[];
  executors?: boolean;
  all_supervisors?: boolean;
  trigger_group_supervisors?: boolean;
}

export enum RecipientOptionType {
  // EMAIL = 'EMAIL', // Not yet implemented, requires some sort of "unsubscribe" feature
  EMPLOYEE = 'EMPLOYEE',
  EMPLOYEEGROUP = 'EMPLOYEEGROUP',
  EXECUTOR = 'EXECUTOR',
  ALL_SUPERVISORS = 'ALL_SUPERVISORS',
  TRIGGER_GROUP_SUPERVISORS = 'TRIGGER_GROUP_SUPERVISORS'
}
